import { Stack } from "@mantine/core"
import {
  BlurredOverlayWithModal,
  Card,
  EqualWidthGrid,
  ErrorBox,
  Loader,
  SectionHeader,
} from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { SETTINGS_SCOPE } from "@tfg/types/constants/communication-studio.constant"
import { PermissionLevelEnum } from "@tfg/types/endpoints/subscriptionPlan"

import { SUPPORT_EMAIL } from "~/constants/email"
import { ComponentModal } from "~/pages/Brand/CommunicationStudio/Content/ComponentModal"
import { ComponentsEditor } from "~/pages/Brand/CommunicationStudio/Content/ComponentsEditor"
import { ContentFiltering } from "~/pages/Brand/CommunicationStudio/Content/ContentFiltering"
import { useComponentCreation } from "~/pages/Brand/CommunicationStudio/contexts/componentCreation/useComponentCreation"
import { useOrganizationSubscriptionPlanPermissions } from "~/pages/Brand/CommunicationStudio/contexts/organizationSubscriptionPlanPermissions/useOrganizationSubscriptionPlanPermissions"
import { useAuth } from "~/store/auth-context"

export const ComponentsEditorPage = () => {
  const { t } = useTranslation("communicationStudio")
  const { isAdmin } = useAuth()
  const { permissions } = useOrganizationSubscriptionPlanPermissions()
  const { productPageComponents, isLoadingProductPageComponents, error } =
    useComponentCreation()

  const isReadOnly =
    permissions?.[SETTINGS_SCOPE.COMPONENT_CUSTOMISATION]?.level ===
      PermissionLevelEnum.READONLY && !isAdmin

  if (error) {
    return <ErrorBox error={error} />
  }

  if (isLoadingProductPageComponents) {
    return <Loader />
  }

  return (
    <Stack pos="relative" mah="80vh" gap="var(--tfg-organism-padding-y)">
      {isReadOnly && (
        <BlurredOverlayWithModal
          title={t("lockedFeatureOverlay.contentFiltering.title")}
          message={t("lockedFeatureOverlay.contentFiltering.message")}
          buttonText={t("lockedFeatureOverlay.contentFiltering.buttonText")}
          onButtonClick={() => {
            window.open(
              `mailto:${SUPPORT_EMAIL}?subject=Upgrade%20to%20PRO%20plan`,
              "_blank"
            )
          }}
        />
      )}
      <SectionHeader
        title={t("tabs.content.header.title")}
        subtitle={t("tabs.content.header.subtitle")}
      />
      <EqualWidthGrid
        justify="flex-start"
        blockAlign="flex-start"
        preventWrap={false}
      >
        <Card w="100%" h="70vh" style={{ overflow: "hidden" }}>
          <Card.Header>
            <SectionHeader
              title={t("tabs.content.componentsEditor.title")}
              subtitle={t("tabs.content.componentsEditor.subtitle")}
            />
          </Card.Header>
          {productPageComponents && <ComponentsEditor />}
        </Card>
        <Card w="100%" h="100%" mah="60vh" mih="100%">
          <Card.Header>
            <SectionHeader
              title={t("tabs.content.contentFiltering.title")}
              subtitle={t("tabs.content.contentFiltering.subtitle")}
            />
          </Card.Header>
          <ContentFiltering />
        </Card>
      </EqualWidthGrid>
      <ComponentModal />
    </Stack>
  )
}
